import { render, staticRenderFns } from "./MailLabel.vue?vue&type=template&id=49a1c023&scoped=true"
import script from "./MailLabel.vue?vue&type=script&lang=js"
export * from "./MailLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a1c023",
  null
  
)

export default component.exports